import { useMutation } from '@tanstack/react-query';
import { retailAdService } from 'shared/src/api';

// iOS: RetailAdClient.sendDisplayEvent
export const usePostRetailAdDisplayEvent = () => {
  return useMutation({
    mutationFn: (executableId: number) =>
      retailAdService.postRetailAdDisplayEvent(executableId),
    // 노출 카운팅용 — 실패해도 UX 영향 없음 (iOS try? 와 동일)
    throwOnError: false,
  });
};
